export type TagType = (typeof TAG_TYPES)[number];

export const TAG_TYPES = [
  "action",
  "alert",
  "api-key",
  "bookmark",
  "card",
  "channel",
  "cloud-migration",
  "collection",
  "collection-tree",
  "content-translation",
  "dashboard",
  "dashboard-question-candidates",
  "database",
  "document",
  "embedding-hub-checklist",
  "field",
  "field-values",
  "glossary",
  "indexed-entity",
  "logger-preset",
  "model-index",
  "notification",
  "parameter-values",
  "permissions-group",
  "persisted-info",
  "persisted-model",
  "revision",
  "schema",
  "segment",
  "session-properties",
  "snippet",
  "subscription",
  "subscription-channel",
  "transform",
  "table",
  "task",
  "timeline",
  "timeline-event",
  "transform",
  "user",
  "public-dashboard",
  "embed-dashboard",
  "public-card",
  "embed-card",
  "public-action",
  "unique-tasks",
  "user-key-value",
] as const;

export const TAG_TYPE_MAPPING = {
  collection: "collection",
  "content-translation": "content-translation",
  card: "card",
  dashboard: "dashboard",
  database: "database",
  document: "document",
  "indexed-entity": "indexed-entity",
  table: "table",
  dataset: "card",
  action: "action",
  segment: "segment",
  metric: "card",
  snippet: "snippet",
  pulse: "subscription",
  transform: "transform",
} as const;
